import { Component } from 'san';

import { IOrganization } from 'src/models';

export default class ProjectFilterCreateOrganization extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        checkedItems() {
            const items: IOrganization[] = this.data.get('data.items');
            return _.filter(items, { _is_checked: true });
        }
    }

    inited() {
    }

    toggleCheck(item: IOrganization) {
        this.fileCheckedOrganization(item);
    }

    clear() {
        this.fileCheckedOrganization();
    }

    fileCheckedOrganization(item?: IOrganization) {
        this.dispatch('UI:project-filter-create-organization-changed', item);
    }

}